import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import SportPage from "@/pages/SportPage";
import LegalPage from "@/pages/LegalPage";
import Standings from "@/pages/Standings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/standings" element={<Standings />} />
            <Route path="/sports/:slug" element={<SportPage />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#031952",
            border: "1px solid #075AEC",
            color: "#FFFFFF",
          },
        }}
      />
    </div>
  );
}

export default App;
